import React from "react";
import { Palmtree } from "lucide-react";
import { useLang } from "../i18n";
import { useSettings } from "../SiteSettings";

export const VacationBanner = () => {
  const { lang } = useLang();
  const settings = useSettings();
  const vac = settings.vacation;
  if (!vac || !vac.active) return null;
  const fallback = lang === "en" ? "We're currently on holiday." : "Wir befinden uns aktuell im Urlaub.";
  const msg = (lang === "en" ? vac.message_en : vac.message_de) || fallback;
  return (
    <div
      data-testid="vacation-banner"
      className="fixed top-0 left-0 right-0 z-[60] bg-qs-gold text-black shadow-md"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-2.5 flex items-center justify-center gap-2 text-center">
        <Palmtree size={16} className="shrink-0" />
        <p className="font-outfit text-xs sm:text-sm font-semibold tracking-wide">{msg}</p>
      </div>
    </div>
  );
};

export default VacationBanner;
